document.addEventListener("DOMContentLoaded", function () {
  // Lazy-load YouTube/Vimeo
  document.querySelectorAll('.external-video-lazy').forEach(function(wrapper) {
    wrapper.addEventListener('click', function() {
      const videoId = wrapper.dataset.videoId;
      const host = wrapper.dataset.host;
      const iframe = document.createElement('iframe');

      if (host === 'youtube') {
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      } else if (host === 'vimeo') {
        iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      }

      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      iframe.style.width = '100%';
      iframe.style.height = '100%';

      wrapper.innerHTML = '';
      wrapper.appendChild(iframe);
    });
  });

  // Lazy-load native video
  const lazyVideos = document.querySelectorAll("video.lazy-product-video");
  if ("IntersectionObserver" in window) {
    let videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          if (video.dataset.src && !video.src) {
            video.src = video.dataset.src;
            video.load();
            observer.unobserve(video);
          }
        }
      });
    });

    lazyVideos.forEach(video => videoObserver.observe(video));
  }
});
